module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fpara2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("The Curfew tolls the Knell of parting Day,")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("The lowing Herd winds slowly o’er the Lea,")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("The Plow-man homeward plods his weary Way,")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("And leaves the World to Darkness, and to me.")]), _vm._v(" "), _c('p', {
    staticClass: "fpara1"
  }, [_vm._v("Thomas Gray, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Elegy Written in a Country Church-Yard")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-895f45d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Front1.vue
// module id = 75
// module chunks = 0